import { 
    setCurrentUser, setAppMenus, setBaseUrl, setMyKomatsuBaseUrl, setCartCount, setMyKomatsuRegion, setKomatsuCareBrochures, setMapCenter, setAppLinks, setIsMinExpoEnabled
} from './actions';

 
const dispatchsetCurrentUser = (dispatch:any) => (loaclparma:any) =>{
  dispatch(setCurrentUser(loaclparma));
}

const dispatchsetbaseUrl = (dispatch:any) => (loaclparma:any) =>{
    dispatch(setBaseUrl(loaclparma));
}

const dispatchsetAppMenus = (dispatch: any) => (loaclparma: any) => {
    dispatch(setAppMenus(loaclparma));
}

const dispatchsetAppLinks = (dispatch: any) => (loaclparma: any) => {
    dispatch(setAppLinks(loaclparma));
}

const dispatchMyKomatsuBaseUrl = (dispatch: any) => (loaclparma: any) => {
    dispatch(setMyKomatsuBaseUrl(loaclparma));
}
const dispatchCartCount = (dispatch: any) => (loaclparma: any) => {
    dispatch(setCartCount(loaclparma));
}

const dispatchMyKomatsuRegion = (dispatch: any) => (localparam: any) => {
    dispatch(setMyKomatsuRegion(localparam));
}

const dispatchIsMinExpoEnabled = (dispatch: any) => (localparam: any) => {
    dispatch(setIsMinExpoEnabled(localparam));
}

const dispatchKomatsuCareBrochures = (dispatch: any) => (localparam: any) => {
    dispatch(setKomatsuCareBrochures(localparam));
}

const dispatchMapCenter = (dispatch: any) => (localparam: any) => {
    dispatch(setMapCenter(localparam));
}

const operations = {
    dispatchsetCurrentUser, dispatchsetAppMenus, dispatchsetbaseUrl, dispatchMyKomatsuBaseUrl, dispatchCartCount,
    dispatchMyKomatsuRegion, dispatchKomatsuCareBrochures, dispatchMapCenter, dispatchsetAppLinks, dispatchIsMinExpoEnabled
};

export default operations;
